import { render, staticRenderFns } from "./moonSampleInfor.vue?vue&type=template&id=020074ce&scoped=true&"
import script from "./moonSampleInfor.vue?vue&type=script&lang=js&"
export * from "./moonSampleInfor.vue?vue&type=script&lang=js&"
import style0 from "./moonSampleInfor.vue?vue&type=style&index=0&id=020074ce&lang=scss&scoped=true&"
import style1 from "./moonSampleInfor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020074ce",
  null
  
)

export default component.exports